export class BuildInfo {
    // @ts-ignore
    public static readonly appVersion = CA_CONFIG.VERSION
    // @ts-ignore
    public static readonly buildDate = CA_CONFIG.BUILDDATE
    // @ts-ignore
    public static readonly intercomAppId = CA_CONFIG.INTERCOM_APPID
    // @ts-ignore
    public static readonly angularModeEnv = CA_CONFIG.ANGULAR_MODE_ENV
}